"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TermDefinition = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
function TermDefinition(props) {
    return ((0, jsx_runtime_1.jsxs)("div", { className: "rounded-xl border border-topia-black p-4 ".concat(props.className), children: [(0, jsx_runtime_1.jsx)("p", { className: "text-lg font-black text-topia-black", children: props.term }), props.italics && ((0, jsx_runtime_1.jsx)("p", { className: "text-sm font-bold italic text-topia-black", children: props.italics })), (0, jsx_runtime_1.jsx)("p", { className: "mt-2 text-md text-topia-black", children: props.defintiion })] }));
}
exports.TermDefinition = TermDefinition;
